export default "__VITE_PUBLIC_ASSET__40424261__"